// src/components/VisitReadyCard.jsx
//
// Today-screen card: "Your visit summary from Dr X is ready" for a visit signed
// in the last 7 days that the patient has not opened yet. Renders nothing while
// loading, on error, or when there is no such visit — a failed fetch must never
// get in the way of the Today screen. "Opened" is remembered per device in
// localStorage (utils/visitSummary.js, guarded with try/catch).

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { usePatient } from '../context/PatientContext';
import patientVisitApi from '../services/patientVisitApi';
import { findNewVisit, readSeenVisitIds } from '../utils/visitSummary';

export default function VisitReadyCard() {
  const { patient } = usePatient();
  const navigate = useNavigate();
  const [visit, setVisit] = useState(null);

  useEffect(() => {
    if (!patient?.id) return undefined;
    let cancelled = false;
    patientVisitApi.list(patient.id)
      .then(items => { if (!cancelled) setVisit(findNewVisit(items, readSeenVisitIds(patient.id))); })
      .catch(() => { if (!cancelled) setVisit(null); });
    return () => { cancelled = true; };
  }, [patient?.id]);

  if (!visit) return null;

  return (
    <button
      type="button"
      className="today-insight"
      style={{ marginBottom: 16 }}
      onClick={() => navigate(`/patient/visits/${visit.id}`)}
    >
      <span className="today-insight-icon" aria-hidden="true"><Icon name="stethoscope" size={16} /></span>
      <span className="today-insight-text">
        <strong>Your visit summary from {visit.doctor} is ready</strong>
        {visit.dateLabel ? ` · ${visit.dateLabel}` : ''}
      </span>
      <Icon name="chevronRight" size={14} />
    </button>
  );
}
